<template>
  <div class="optimizer-input-observer debug-input-observer" v-if="enableDebugMode">
    <collapse-group title="Status">
      Goals ready: <strong>{{$ready_goals}}</strong><br />
      Commitments ready: <strong>{{$ready_commitments}}</strong><br />
      Optimizer worker ready: <strong>{{$ready_optimizer_worker}}</strong><br />
      Timeslot worker ready: <strong>{{$ready_timeslot_worker}}</strong><br />
      Optimizer input ready: <strong>{{$ready_optimizer_input}}</strong><br />
      ----------------------------------------<br />
      input_can_be_prepared: <strong>{{input_can_be_prepared}}</strong><br />
      optimizer_can_be_called: <strong>{{optimizer_can_be_called}}</strong><br />
    </collapse-group>

    <collapse-group title="Input getters" :init-collapse="true">
      <a href="#" @click.prevent="show_getters = !show_getters">show getters</a>
      <div v-if="show_getters">
        optimizer_input_related_goal_list:
        <pre class="mini-pre">{{optimizer_input_related_goal_list}}</pre>
        optimizer_input_commitments:
        <pre class="mini-pre">{{optimizer_input_commitments}}</pre>
        optimizer_input_existing_events:
        <pre class="mini-pre">{{optimizer_input_existing_events}}</pre>
        optimizer_input_tsc_data:
        <pre class="mini-pre">{{optimizer_input_tsc_data}}</pre>
        optimizer_input_sequences:
        <pre class="mini-pre">{{optimizer_input_sequences}}</pre>
        optimizer_input_tasks:
        <pre class="mini-pre">{{optimizer_input_tasks}}</pre>
        <hr />
        timeslot_exceptions:
        <pre class="mini-pre">{{timeslot_exceptions}}</pre>
        timeslot_weekday_prefs:
        <pre class="mini-pre">{{timeslot_weekday_prefs}}</pre>
        optimizer_manual_dayplan:
        <pre class="mini-pre">{{optimizer_manual_dayplan}}</pre>
      </div>
    </collapse-group>

    <collapse-group title="Optimizer input diff">
      <el-checkbox :checked="false" @input="onShowHideUnchanged">Show unchanged</el-checkbox>
      <div v-html="diff"></div>
    </collapse-group>

    <collapse-group title="Diff history" :init-collapse="true">
      <collapse-group
        v-for="(diff, idx) in diff_history"
        :key="idx"
        :title="'Diff: ' + idx"
        :init-collapse="true">
        <div v-html="diff"></div>
      </collapse-group>
    </collapse-group>

    <!--
    <collapse-group title="Optimizer input" :init-collapse="true">
      <pre class="mini-pre">{{input_json}}</pre>
    </collapse-group>
    -->
    <hr />

    <el-button @click="onManualInit" size="small" type="primary">Go</el-button>
    <el-button @click="onManualOptimize" size="small" type="primary">Opt</el-button>

    <el-button @click="onClickDebug" size="small">Vue.pursue</el-button>
    <!-- <pre class="mini-pre">{{registry}}</pre> -->

    <!-- TODO: Add tests here for typical test by directly mutating state -->
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import debounce from 'lodash.debounce';
import optimizer_watchers from '@/store/optimizer/watchers'
import clonedeep from 'lodash.clonedeep'
import { OPTIMIZER_TRIGGER_DEBOUNCE_TIME, TRIGGER_OPTIMIZER_ON_REGISTRY_CHANGE } from '@/features'

import 'jsondiffpatch/dist/formatters-styles/html.css'
const jsondiffpatch = require('jsondiffpatch');

export default {
  mixins: [ optimizer_watchers ],
  props: {
    enableDebugMode: {
      default: false
    }
  },
  data() {
    return {
      show_getters: false,
      init_json_diffpatch: true,
      previous_input: {},
      // input_json: '',
      diff: '',
      diff_history: [],
      optimizer_trigger_debounced: () => {},
    }
  },
  created() {
    this.optimizer_trigger_debounced = debounce(
      this.optimizer_trigger,
      OPTIMIZER_TRIGGER_DEBOUNCE_TIME )

    this.onShowHideUnchanged(false);
  },
  watch: {
    'registry': {
      handler( value ) {
        // console.log("WATCH:REGISTRY")
        if ( TRIGGER_OPTIMIZER_ON_REGISTRY_CHANGE && this.optimizer_can_be_called ) {
          this.optimizer_trigger_debounced()
        }
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters('optimizer', [
      'optimizer_input_related_goal_list',
      'optimizer_input_commitments',
      'optimizer_input_existing_events',
      'optimizer_input_tsc_data',
      'optimizer_input_sequences',
      'optimizer_input_tasks',
      'optimizer_input_commitment_settings',
      'optimizer_input',
      'optimizer_manual_dayplan'
    ]),
    registry() {
      let registry_state = this.$models.goalMeta.getRegistryState()
      return registry_state.res
    }
  },
  methods: {
    ...mapActions('optimizer', [
      'optimizer_trigger',
    ]),

    /* ------------------------------- DEBUG ------------------------------- */

    onManualInit() {
      this.optimizier_initial_subscribe();
    },

    onManualOptimize() {
      this.optimizer_trigger()
    },

    onShowHideUnchanged(value) {
      if (value) {
        jsondiffpatch.formatters.html.showUnchanged();
      } else {
        jsondiffpatch.formatters.html.hideUnchanged();
      }
    },

    onNewOptimizerInput( new_input_raw ) {

      let old_input = this.previous_input
      let new_input = clonedeep(new_input_raw)

      let delta = jsondiffpatch.create({
        objectHash(obj) {
          return obj.$id
            || obj.timeslotCollectionId
            || obj.commitmentId
            || obj.taskId
            || obj.sequenceItemId
            || obj.from;
        },
        arrays: {
          detectMove: true,
          includeValueOnMove: false
        },
        textDiff: {
          minLength: 60
        },
        cloneDiffValues: true
      }).diff(old_input, new_input);

      this.diff = jsondiffpatch.formatters.html.format(delta, old_input);
      this.diff_history.push( this.diff );

      this.previous_input = new_input;
    },

    onClickDebug() {

      let goalId = 'XXXJ84VZRSGIz3u8PHnQ8A'
      let tasks = this.$models.task.with({ goalId }).getters.lane_task_list_current_user
      let task = tasks.items['UBnbRULNTky0tmlcC8iWMg'][0]

      console.log("Vue.pursue", tasks, task);
      /* for ( let prop in task ) {
        console.log(">>", prop, Vue.pursue(task, prop).computed)
      }
      console.log("------")
      for ( let prop in task.$state ) {
        console.log(">>", prop, Vue.pursue(() => task.$state[prop]).computed)
      }
      console.log( Vue.pursue(() => task.$state).computed )
      console.log( Vue.pursue($registry.state) )
      console.log( Vue.pursue($registry.state.res.goal.XXXJ84VZRSGIz3u8PHnQ8A.user_list.GX4vxXk0cuNdBg0BdbcziqOayAw2.task_meta['XdG8-ivVTIeNDt2aSTW0ng']) )
      */

      function FindDep( node, search_string, path = 'res' ) {
        let list = Vue.pursue(node)
        if ( list.computed.includes( search_string ) ) {
          console.log(path)
        }
        for ( let prop in node ) {
          if ( Array.isArray( node[ prop ] ) ) {
            FindDep( node[ prop ], search_string, path + '.' + prop )
          } else if ( typeof node[ prop ] === 'object' ) {
            FindDep( node[ prop ], search_string, path + '.' + prop )
          } else {
          }
        }
      }

      FindDep( window.$registry.state.res, 'optimizer/optimizer_input' )
    }
  }
}
</script>

<style>
#app .show-debug-tool .debug-input-observer {
  display: block;
  border: 3px solid red;
  background-color: white;
  width: 300px;
  position: absolute;
  right: 0;
  top: 0;
  margin-top: 50px;
  height: calc(100% - 50px);
  z-index: 99;
  overflow-y: scroll;
}
#app .debug-input-observer {
  display: none;
}
.optimizer-input-observer pre.mini-pre {
  font-size: 8pt;
  line-height: 1;
  white-space: pre;
  margin: 0;
  padding: 0;
}
.optimizer-input-observer pre.renderjson {
  margin: 0;
  padding: 0;
  background-color: white;
  font-size: 8pt;
  line-height: 1;
  height: 100%;
  width: 100%;
}
.optimizer-input-observer .jsondiffpatch-delta pre {
  overflow: unset;
  /*background-color: white;*/
}
.optimizer-input-observer .jsondiffpatch-delta pre,
.optimizer-input-observer .jsondiffpatch-delta {
  font-size: 8pt;
  line-height: 1.1;
  margin: 0;
  padding: 0;
}
.optimizer-input-observer .jsondiffpatch-delta ul {
  padding: 0 0 0 10px;
}
</style>
